import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import Constitute from '../../entities/booking/constitute';

interface ConstituteState extends ListState<Constitute>{
    editConstitute:Constitute
}
class ConstituteMutations extends ListMutations<Constitute>{

}
class ConstituteModule extends ListModule<ConstituteState,any,Constitute>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Constitute>(),
        loading:false,
        editConstitute:new Constitute()
    }
    actions={
        async getAll(context:ActionContext<ConstituteState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Constitute/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Constitute>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<ConstituteState,any>,payload:any){
            await Ajax.post('/api/services/app/Constitute/Create',payload.data);
        },
        async createWithImages(context:ActionContext<ConstituteState,any>,payload:any){
            await Ajax.post('/api/services/app/Constitute/CreateWithImages',payload.data);
        },
        async update(context:ActionContext<ConstituteState,any>,payload:any){
            await Ajax.put('/api/services/app/Constitute/Update',payload.data);
        },
        async updateWithImages(context:ActionContext<ConstituteState,any>,payload:any){
            await Ajax.put('/api/services/app/Constitute/UpdateWithImages',payload.data);
        },
        async delete(context:ActionContext<ConstituteState,any>,payload:any){
            await Ajax.delete('/api/services/app/Constitute/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<ConstituteState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Constitute/Get?Id='+payload.id);
            return reponse.data.result as Constitute;
        }
    };
    mutations={
        setCurrentPage(state:ConstituteState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:ConstituteState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:ConstituteState,constitute:Constitute){
            state.editConstitute=constitute;
        }
    }
}
const constituteModule=new ConstituteModule();
export default constituteModule;